module.exports = __webpack_public_path__ + "img/home_vr_s_icon.6dc3899.png";